import { translation } from 'I18n/i18n'
import { PBoldExt, PExt } from 'components/myTags/myTags'
import HTMLReactParser from 'html-react-parser'
import { useSelector } from 'react-redux'
import { Colors } from 'styles/colors'

export default function PresentationBloc0() {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const bloc0Style = {
      height: '580px',
      padding: '30px 100px',
      background: Colors.white,
   }
   return (
      <>
         <video
            src={`/video/60 Years Le Neubourg_${HTMLReactParser(
               translation(lang, 'siteNeubourg', 'video'),
            )}.mp4`}
            controlsList='nodownload nofullscreen noremoteplayback disablePictureInPicture'
            controls
            loop
            muted
            style={{ width: '1055px' }}
         ></video>
         <div className='w100 flex column alignStart' style={bloc0Style}>
            <PBoldExt bold fontSize='22px' color={Colors.gris1}>
               LE NEUBOURG
            </PBoldExt>
            <br />
            <PExt fontSize='21px' color={Colors.gris1}>
               {HTMLReactParser(translation(lang, 'presentationSite', 'bloc0Txt1'))}
            </PExt>
            <br />
            <PExt fontSize='21px' color={Colors.gris1}>
               {HTMLReactParser(translation(lang, 'presentationSite', 'bloc0Txt2'))}
            </PExt>
            <br />
            <PExt fontSize='21px' color={Colors.gris1}>
               {HTMLReactParser(translation(lang, 'presentationSite', 'bloc0Txt3'))}
            </PExt>
            <br />
            <PExt fontSize='21px' color={Colors.gris1}>
               {HTMLReactParser(translation(lang, 'presentationSite', 'bloc0Txt4'))}
            </PExt>
            <br />
            <PExt fontSize='21px' color={Colors.gris1}>
               {HTMLReactParser(translation(lang, 'presentationSite', 'bloc0Txt5'))}
            </PExt>
         </div>
      </>
   )
}
